export default __webpack_public_path__ + "static/media/logo-pinterest.79835f81.svg";